import {
  UIFetchStatus,
  UIAvailableExtraProducts,
  UIClientFetchError,
  UIProductSelection,
  UIPreOptInSelected,
  UIPageLoadTime
} from "@flights/types";

type ExtraProductsState = {
  fetchStatus: UIFetchStatus;
  extraProducts?: UIAvailableExtraProducts;
  selected: UIProductSelection;
  error?: UIClientFetchError;
  preOptedAncillaries: UIPreOptInSelected;
  pageLoadTime: UIPageLoadTime;
};

export const getInitialState = (): ExtraProductsState => ({
  fetchStatus: "initial",
  extraProducts: {},
  selected: {},
  error: undefined,
  preOptedAncillaries: {},
  pageLoadTime: {}
});

export type State = ExtraProductsState;
